import MUIMenuItem from '@mui/material/MenuItem'

export const DropdownOption = MUIMenuItem
